import React, { Fragment } from 'react';
import Defs from './defs.svg';
import Symbols from './symbols.svg';

/**
 * Render the symbols and the fill definitions. They are rendered as two
 * separate `<svg>` elements because the fills do not work when set to
 * `display: none`, yet the symbols require it.
 */
const SocialIconSymbols = () => (
  <>
    <Defs />
    <Symbols />
  </>
);

export default SocialIconSymbols;
